export const getElevation = (elevation?: boolean, float?: boolean): boolean => !(!elevation || (!elevation && !float));
